import { HeaderHero, NavBarColorSwitcher, Spacer, WrapperBody } from "components";
import * as React from 'react';
export default {
  HeaderHero,
  NavBarColorSwitcher,
  Spacer,
  WrapperBody,
  React
};